export default __webpack_public_path__ + "static/media/P_wdt_c_cap_0.0497affa.mp3";